import React from 'react';

interface CancelledStepsProps {
  steps: string[];
  currentStepNumber: number;
}

const CancelledSteps: React.FC<CancelledStepsProps> = ({ steps, currentStepNumber }) => (
  <ul className="daikin-proDetailsProcess cancel_oeder">
    {steps.map((step, index) => (
      <li
        key={index}
        className={`daikin-num 
          ${index + 1 <= currentStepNumber ? 'active' : 'inactive'} 
          ${step === 'Cancelled' ? 'cancelled-step' : ''}`}
      >
        <div className="daikin-progNum">{index + 1 < currentStepNumber ? '✔' : index + 1}</div>
        <div className="daikin-detailsSteps">{step}</div>
      </li>
    ))}
  </ul>
);

export default CancelledSteps;
